import { ReactNode } from "react";
import classNames from "classnames";

import { TestProps } from "shared/types";

interface Props extends TestProps {
  label: ReactNode;
  value: ReactNode;
  direction?: "vertical" | "horizontal";
  valueAlign?: "left" | "right";
}

const AttributeRow = ({
  label,
  value,
  direction = "horizontal",
  valueAlign = "left",
  testId,
}: Props) => {
  const isHorizontal = direction === "horizontal";

  return (
    <div
      className={classNames("flex gap-2 text-xs", {
        "flex-col": !isHorizontal,
        "flex-row items-start border-b border-gray-50 pb-1": isHorizontal,
      })}
      data-testid={testId}
    >
      <div
        className={classNames("font-bold min-w-0", {
          "wrap-break-word flex-1 max-w-1/2": isHorizontal,
        })}
      >
        {label}
      </div>
      <div
        className={classNames("min-w-0", {
          "flex-1 max-w-1/2 wrap-break-word": isHorizontal,
          "text-right": valueAlign === "right",
        })}
      >
        {value}
      </div>
    </div>
  );
};

export default AttributeRow;
